import { render } from "./IDCard.vue?vue&type=template&id=64faf7f6"
import script from "./IDCard.vue?vue&type=script&lang=js"
export * from "./IDCard.vue?vue&type=script&lang=js"

import "./IDCard.vue?vue&type=style&index=0&id=64faf7f6&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__